(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CustomTemplateLevelOneController', CustomTemplateLevelOneController);
    CustomTemplateLevelOneController.$inject = ['$scope', '$filter','$uibModal', 'CompanyReportService', 'PortfolioTrackerService', '$window', '$state', 'GenericService'];
    function CustomTemplateLevelOneController($scope, $filter, $uibModal, CompanyReportService, PortfolioTrackerService, $window, $state, GenericService) {
       
        $scope.showModal = false;
        $scope.rightSection = [];
        $scope.leftSection = [];
        $scope.action = $state.params.action;
        var baseJson = {
            "companyCode": null,
            "companyName": null,
            "financialsDataUnit": null,
            "financialsDataOrder": null,
            "reportFormat":0,
            "reportType":null,
            "template":{
               "templatename":null,
               "ordering":[],
               "selectedSector":'G',
               "customFormState": null
            }
        }
        $scope.paramList = [];
        $scope.isAdminEdit = $state.params.isAdminEdit;
        $scope.restrictions = {};
        $scope.getDefaultParamJson = function(subscription) {
            CompanyReportService.getDefaultParamJson(subscription).then(
				function(successData) {
                    $scope.defaultJson = JSON.parse(successData.templateJson);
                    baseJson.template.customFormState = $scope.defaultJson.template.customFormState;
			}, function(errorData) {

            })
        }
        
        //$scope.defaultJson = defaultJson;
        $scope.templateJson = $state.params.templateJson ? $state.params.templateJson : baseJson;
        $scope.createdOn = $state.params.createdOn;
        localStorage.setItem('defaultTemplateJson', JSON.stringify(baseJson));
        $scope.models = {
            selected: null,
            lists: {
                "Select": [], 
                "Selected": []
            }
        };

        $scope.removeItem = function(index, selection, paramId) {
            $scope.models.lists[selection].splice(index, 1);
            if(selection == 'Select') {
                if(_.find($scope.models.lists['Selected'], ['paramId', paramId])) {
                    if(paramId == 'crisilOutlook') {
                        $scope.templateJson.template['industryOutlook'] = $scope.defaultJson.template['industryOutlook'];
                        $scope.templateJson.template['economyOutlook'] = $scope.defaultJson.template['economyOutlook'];
                    } else if(paramId == 'companyOverview') {
                        $scope.templateJson.template['beneficialOwnership'] = $scope.defaultJson.template['beneficialOwnership'];
                        $scope.templateJson.template[paramId] = $scope.defaultJson.template[paramId];
                    } else {
                        $scope.templateJson.template[paramId] = $scope.defaultJson.template[paramId];
                    }
                }
            } else {
                if(_.find($scope.models.lists['Select'], ['paramId', paramId])) {
                    if(paramId == 'crisilOutlook') {
                        delete $scope.templateJson.template['industryOutlook'];
                        delete $scope.templateJson.template['economyOutlook'];
                    } else if(paramId == 'companyOverview') {
                        delete $scope.templateJson.template['beneficialOwnership'];
                        delete $scope.templateJson.template[paramId];
                    } else {
                        delete $scope.templateJson.template[paramId];
                    }
                }
            }
        }

        $scope.findAllTemplateParams = function() {
            var subscription = '';
            GenericService.getUserModuleAccessData().then(function (result) {
                if (result['COMPANY_INFO_REPORT_LITE_PLUS'])
                    subscription = 'LP';
                if (result['COMPANY_INFO_REPORT_ADVANCED_PLUS'])
                    subscription = 'AP';
                if (result['COMPANY_INFO_REPORT_COMPREHENSIVE_PLUS'])
                    subscription = 'CP';
                if(result['COMPANY_INFO_REPORT1']) {
                    subscription = 'LP';
                }
                if(result['COMPANY_INFO_REPORT2']) {
                    subscription = 'AP';
                }
                if(result['COMPANY_INFO_REPORT3']) {
                    subscription = 'CP';
                }
                $scope.getDefaultParamJson(subscription);
                CompanyReportService.findAllTemplateParams(subscription).then(
                    function (successData) {
                        if ($scope.templateJson.template.ordering.length > 0) {
                            for (var index = 0; index < $scope.templateJson.template.ordering.length; index++) {
                                var element = $scope.templateJson.template.ordering[index];
                                // _.remove(successData.paramList, function (n) { return n.id == element.id });
                            }
                        }
                        localStorage.setItem('paramList', JSON.stringify(successData.paramList));
                        $scope.paramList = successData.paramList;
                        $scope.leftSection = successData.paramList;
                        $scope.models.lists.Select = successData.paramList;
                        $scope.restrictions = successData.restriction;
                        $scope.models.lists.Selected = $scope.templateJson.template.ordering;
                    }, function (errorData) {

                    })
            });
            
            //console.log(keycloak.hasRealmRole('ROLE_LITE_PLUS'))
            //console.log(keycloak.hasRealmRole('ROLE_ADVANCED_PLUS'))
            //console.log(keycloak.hasRealmRole('ROLE_COMPREHENSIVE_PLUS'))
        }

        $scope.resetTemplate = function() {
            $scope.findAllTemplateParams();
            var tempName = $scope.templateJson.template.templatename;
            $scope.templateJson = JSON.parse(localStorage.getItem('defaultTemplateJson'));
            $scope.templateJson.template.templatename = tempName ? tempName : null;
        }

        $scope.findAllTemplateParams();

        $scope.demofunction = function() {
            $uibModalInstance.dismiss('cancel');
        }
        
        $scope.createCustomizedReport = function() {
            //console.log("Inside create custom button:",JSON.stringify($scope.defaultJson))
            localStorage.setItem('defJson', JSON.stringify($scope.defaultJson));
            $scope.templateJson.template.ordering = $scope.models.lists.Selected;
            console.log("Data>>> ", JSON.stringify($scope.templateJson.template.ordering.at(0).paramId));
            if($scope.templateJson.template.ordering.length==1 && $scope.templateJson.template.ordering.at(0).paramId =='summarySheet'){
                console.log("Inside if condition");
                //$window.alert("Kindly select one or more sections along with Summary Sheet to generate a report.");
                $scope.message ={
                    message: 'Kindly select one or more sections along with Summary Sheet to generate a report.',
                    notify: false,
                    state: 'summary',
                    summary :true
                };
                $uibModal.open({
                    templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
                    size: 'sm',
                    scope: $scope,
                    controller: 'ConfirmationModalController'
                    })
                }
            else{
                $state.go('createcustomizedreport', {
                templateJson: $scope.templateJson,
                createdOn:$scope.createdOn,
                action: $scope.action,
                isAdminEdit: $scope.isAdminEdit,
                restrictions: $scope.restrictions
                });
            }
        }

        $scope.selectAllSections = function() {
            var tempName = $scope.templateJson.template.templatename;
            $scope.templateJson = $scope.defaultJson;
            $scope.templateJson.template.templatename = tempName ? tempName : null;
            $scope.models.lists.Select = [];
            $scope.models.lists.Selected = JSON.parse(localStorage.getItem('paramList'));;
        }

        $scope.$watch('models', function(model) {
            $scope.modelAsJson = angular.toJson(model, true);
        }, true);
    }
})();